import React from 'react';
import { motion } from 'framer-motion';
export function Results() {
  return <section className="py-16 md:py-24 px-4 bg-gray-50 border-t border-gray-200" data-id="element-216">
      <div className="max-w-4xl mx-auto" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-219">
            LO QUE DICEN LOS RESULTADOS
          </h2>
          <p className="text-gray-500 italic text-lg" data-id="element-220">
            (Resultados reales. Sin filtros. Sin Photoshop. Sin promesas de
            milagros.)
          </p>
        </motion.div>

        <div className="mb-20" data-id="element-221">
          <h3 className="text-2xl md:text-3xl font-bold text-gold mb-8 flex items-center gap-3" data-id="element-222">
            <span data-id="element-223">📸</span> ANTES Y DESPUÉS: LO QUE PODÉS ESPERAR
          </h3>

          <div className="space-y-6 text-lg text-gray-600 mb-12" data-id="element-224">
            <p data-id="element-225">
              Antes de mostrarte los resultados, necesitamos ser completamente
              honestos con vos. Porque este sistema no es para los que buscan
              milagros en 7 días. Es para los que entienden que el pelo tarda y
              que la constancia es el único factor que realmente diferencia los
              resultados.
            </p>
            <p data-id="element-226">Esto es lo que ocurre en un protocolo aplicado correctamente:</p>
          </div>

          <div className="space-y-8" data-id="element-227">
            {/* Timeline Item 1 - ANTES */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5
          }} className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-228">
              <div className="relative" data-id="element-229">
                <img src="https://cdn.magicpatterns.com/uploads/csMsbJdsujQFceS3fbdLXW/calvicie_dia_0-removebg-preview.png" alt="Hombre con calvicie visible - antes del tratamiento" className="w-full object-contain opacity-70" data-id="element-230" />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent" data-id="element-231"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-2" data-id="element-232">
                  <span className="bg-gray-200 text-gray-900 text-sm font-bold px-3 py-1 rounded" data-id="element-233">
                    ⬛ DÍA 0
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-234">
                <h4 className="font-bold text-xl text-gray-900 mb-4" data-id="element-235">
                  ANTES DEL SISTEMA MEGAKIT:
                </h4>
                <div className="space-y-3 text-gray-600" data-id="element-236">
                  <p data-id="element-237">
                    Cuero cabelludo rígido, folículos tapados. Entradas
                    retrocediendo, coronilla transparente. 20-50 pelos en el
                    desagüe cada mañana. Pelo fino, opaco, sin vida.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Timeline Item 2 - 30 DÍAS */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5
          }} className="bg-white rounded-lg border border-green-200 overflow-hidden shadow-sm" data-id="element-238">
              <div className="relative" data-id="element-239">
                <img src="https://cdn.magicpatterns.com/uploads/75LW2ngyVr7wbgAu2an2N5/calvicie_2-removebg-preview(1).png" alt="Progreso capilar a los 30 días - leve mejora" className="w-full object-contain opacity-75" data-id="element-240" />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent" data-id="element-241"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-2" data-id="element-242">
                  <span className="bg-green-100 text-green-700 text-sm font-bold px-3 py-1 rounded" data-id="element-243">
                    🟢 DÍA 30
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-244">
                <h4 className="font-bold text-xl text-green-600 mb-4" data-id="element-245">
                  DESPUÉS DE 30 DÍAS CON EL SISTEMA MEGAKIT:
                </h4>
                <div className="space-y-3 text-gray-600" data-id="element-246">
                  <p data-id="element-247">
                    El cuero cabelludo se mueve con más libertad. La caída se
                    redujo notablemente. El pelo tiene más brillo y textura.
                    Algo está cambiando.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Timeline Item 3 - 60 DÍAS */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5
          }} className="bg-white rounded-lg border border-green-300 overflow-hidden shadow-sm" data-id="element-248">
              <div className="relative" data-id="element-249">
                <img src="https://cdn.magicpatterns.com/uploads/aGW1nY8NUrceK9XcuYGuw9/heylloyd-image-1774984334039-removebg-preview.png" alt="Progreso capilar a los 60 días - mejora visible en densidad" className="w-full object-contain opacity-80" data-id="element-250" />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent" data-id="element-251"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-2" data-id="element-252">
                  <span className="bg-green-200 text-green-700 text-sm font-bold px-3 py-1 rounded" data-id="element-253">
                    🟢🟢 DÍA 60
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-254">
                <h4 className="font-bold text-xl text-green-600 mb-4" data-id="element-255">
                  DESPUÉS DE 60 DÍAS CON EL SISTEMA MEGAKIT:
                </h4>
                <div className="space-y-3 text-gray-600" data-id="element-256">
                  <p data-id="element-257">
                    Caída bajo control. Vellos nuevos apareciendo en entradas y
                    coronilla. Más cuerpo, volumen y brillo. El protocolo está
                    funcionando.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Timeline Item 4 - 90 DÍAS */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5
          }} className="bg-white rounded-lg border border-green-400 shadow-[0_0_30px_rgba(34,197,94,0.1)] overflow-hidden" data-id="element-258">
              <div className="relative" data-id="element-259">
                <img src="https://cdn.magicpatterns.com/uploads/m291PsbMrzzQ4hkD8AQtry/calvicie_3-removebg-preview.png" alt="Resultado a los 90 días - pelo con densidad recuperada" className="w-full object-contain opacity-85" data-id="element-260" />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent" data-id="element-261"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-2" data-id="element-262">
                  <span className="bg-green-600 text-white text-sm font-bold px-3 py-1 rounded" data-id="element-263">
                    🟢🟢🟢 DÍA 90
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-264">
                <h4 className="font-bold text-xl text-green-600 mb-4" data-id="element-265">
                  DESPUÉS DE 90 DÍAS CON EL SISTEMA MEGAKIT:
                </h4>
                <div className="space-y-3 text-gray-600" data-id="element-266">
                  <p data-id="element-267">
                    Diferencia visible en densidad y calidad. Vellos nuevos con
                    grosor real. Entradas estabilizadas. Caída en rangos
                    normales. Tenés control.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="mt-12 bg-yellow-50 border border-yellow-200 p-6 rounded-lg" data-id="element-268">
            <h4 className="text-xl font-bold text-yellow-600 mb-4 flex items-center gap-2" data-id="element-269">
              <span data-id="element-270">⚠️</span> UNA ACLARACIÓN HONESTA:
            </h4>
            <div className="space-y-4 text-gray-600" data-id="element-271">
              <p data-id="element-272">
                Los resultados varían según tu estado inicial, genética y
                constancia. No reactivamos folículos cerrados, pero sí frenamos
                la progresión y reactivamos los miniaturizados.
              </p>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-273">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-274">
            POR QUÉ LOS SHAMPOOS Y LOS QUÍMICOS NO FUNCIONAN DE VERDAD
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-275">
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-276">
              <h4 className="font-bold text-xl text-red-500 mb-4" data-id="element-277">
                El problema del Minoxidil:
              </h4>
              <p className="text-gray-600" data-id="element-278">
                Efecto rebote si lo dejás. Irritación en muchos usuarios. Te
                convierte en rehén de una farmacéutica de por vida.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-279">
              <h4 className="font-bold text-xl text-red-500 mb-4" data-id="element-280">
                El problema de los shampoos:
              </h4>
              <p className="text-gray-600" data-id="element-281">
                0.1% de concentración. 90 segundos de contacto. No penetra, no
                actúa, no cambia nada. Marketing puro.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-282">
              <h4 className="font-bold text-xl text-red-500 mb-4" data-id="element-283">
                El problema de la peluquería:
              </h4>
              <p className="text-gray-600" data-id="element-284">
                Efectivos para el momento. Caros para el bolsillo argentino.
                Dependés del profesional para siempre.
              </p>
            </div>
          </div>

          <div className="bg-green-50 border border-green-200 p-8 rounded-lg" data-id="element-285">
            <h4 className="font-bold text-2xl text-gold mb-4" data-id="element-286">
              Lo que hace el Sistema Megakit:
            </h4>
            <p className="text-lg text-gray-600" data-id="element-287">
              6 frentes simultáneos. Activos naturales en concentraciones
              reales. Sin dependencia ni rebote. En tu casa, con ingredientes de
              la dietética, a un costo menor que una pizza por mes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}